import { useState } from "react";
import DialogComponent from "../../../../common/components/functional/dialogs/DialogComponent";
import EditEntryView from "./EditEntryView";

const EditNewEntryModal = () => {
  const [open, setOpen] = useState(true);

  return (
    <DialogComponent
      variant="card"
      open={open}
      autoWidth
      sx={{ padding: "0px" }}
    >
      <EditEntryView cancel={() => setOpen(false)} />
    </DialogComponent>
  );
};

export default EditNewEntryModal;
